import pkg from '../../package.json';

export const environment = {
  production: true,
  package_name: pkg.name,
  package_version: pkg.version,
  title: "Flywheel",
  favicon: "favicon.ico",
  tanstack_dev_tools: false,
};
